module.exports = __webpack_public_path__ + "img/red_header_01.b991421a.png";